import { ServiceData } from '@/types';

import articles from './COOKING_ARTICLES_RS.json';
import recipes from './COOKING_RECIPES_RS.json';
import videos from './COOKING_VIDEOS_RS.json';

export const COOKING_DATA_RS: ServiceData = {
  articles,
  recipes,
  videos,
};
